import state from "@/store/auth/state";
import getters from "@/store/auth/getters";
import mutations from "@/store/auth/mutations";
import * as actions from "@/store/auth/actions";

const authModule = {
	namespaced: true,
	getters,
	mutations,
	actions,
	state,
};

export default authModule;
